import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import PageRoutes from "../utils/routes";

const RequireAuth = ({ allowedRoles }) => {
  const { firmAuth, personnelAuth } = useAuth(); // Get both authentication states
  const location = useLocation();

  // Determine if the user is logged in and what their role is
  const auth = firmAuth?.accessToken ? firmAuth : personnelAuth; // Check which one is logged in
  const role = auth?.user?.role; // Get the role of the authenticated user

  // Check if the user's role is included in allowedRoles
  return allowedRoles.includes(role) ? (
    <Outlet />
  ) : auth?.accessToken ? ( // Check if there is an access token to determine unauthorized access
    <Navigate to={PageRoutes.unauthorized} state={{ from: location }} replace />
  ) : (
    <Navigate to={PageRoutes.unauthorized} state={{ from: location }} replace />
  );

  // return true ? (
  //   <Outlet />
  // ) : auth?.accessToken ? ( //changed from user to accessToken to persist login after refresh
  //   <Navigate to={PageRoutes.unauthorized} state={{ from: location }} replace />
  // ) : (
  //   <Navigate to={PageRoutes.login} state={{ from: location }} replace />
  // );
};

export default RequireAuth;
